"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextCatalogue = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useTranslations = require("../../../hooks/useTranslations");
var _common = require("../../common");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const NextCatalogue = props => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onClick,
    catalogue: {
      url,
      title,
      imageUrl,
      validity
    }
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Catalogue, {
    "data-testid": getTestId(_common.NEXT_CATALOGUE),
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CategoryBox, {
      title: title,
      imageUrl: imageUrl,
      description: validity,
      relativeUrl: url ?? '',
      buttonText: translations.view
    }, title)
  });
};
exports.NextCatalogue = NextCatalogue;
